export default "__VITE_ASSET__CtTrEqSD__"